module.exports = __webpack_public_path__ + "assets/45.jpg?a19e276ff9e7692765eabe662aed6210";